import BenVerifyScreen from "./ben-verify-screen";

export default BenVerifyScreen;
